import SearchPage from "./search-page";
import SearchSubPage from "./sub-page";

const Search = {
    Page : SearchPage,
    SubPage : SearchSubPage
};

export default Search;